// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorFault {
  Underspeed = 0,
  SafetyBreak = 1,
  PhaseFailure = 2,
  SmokeDetector = 3,
  KeySwitchStop = 4,
  ConsecutiveStop = 5,
  MotorUnderspeed = 6,
  ExternalShutdown = 7,
  SeismicMonitor = 8,
  Safety = 9,
  Generic = 10,
  CombplateTopLeft = 11,
  HandrailTopLeft = 12,
  SkirtingTop = 13,
  EmergencyStop = 14,
  CombplateBottomLeft = 15,
  HandrailBottomLeft = 16,
  ChaintensionBottom = 17,
  DriveChain = 18,
  HandrailDrop = 19,
  StepUpthrust = 20,
  CombHeating = 21,
  SkirtingBottom = 22,
  Direction = 23,
  BrokenStepBottom = 24,
  StopSwitchTop = 25,
  HandrailStretch = 26,
  StopSwitchBottom = 27,
  FrequencyConverter = 28,
  StopSwitchAuxiliary = 29,
  FloorCoverTop = 30,
  OverspeedTop = 31,
  UnderspeedTop = 32,
  HandrailMonitorLeft = 33,
  HandrailMonitorRight = 34,
  ServiceBrake = 35,
  EmergencyBrake = 36,
  BrokenStepTop = 37,
  SensorInmgb = 38,
  StepAbsenceTop = 39,
  SensorInvkTop = 40,
  StepAbsenceBottom = 41,
  SensorInvkBottom = 42,
  OverspeedBottom = 43,
  UnderspeedBottom = 44,
  SoftStop = 45,
  ParameterLost = 46,
  SreDrop = 47,
  HandrailTopRight = 48,
  HandrailBottomRight = 49,
  CombplateTopRight = 50,
  CombplateBottomRight = 51,
  SafetyCircuit = 52,
  FloorCoverBottom = 53,
  UndefinedStop = 54,
  ContinuousOperation = 55,
  ReadyToStart = 56,
  MotorOnMains = 57,
  AutomaticService = 58,
  EscalatorRunning = 59,
  Down = 60,
  Up = 61,
  TUVSimulation = 62,
  InspectionMode = 63,
  LightCurtainActive = 64,
  ResetMHardware = 65,
  ResetS0Hardware = 66,
  ResetS1Hardware = 67,
  ResetS2Hardware = 68,
  ResetS3Hardware = 69,
  ResetDHardware = 70,
  ResetMBussRetry = 71,
  ResetS0BussRetry = 72,
  ResetS1BussRetry = 73,
  ResetS2BussRetry = 74,
  ResetS3BussRetry = 75,
  ResetDBussRetry = 76,
  ResetMBufferFull = 77,
  ResetS0BufferFull = 78,
  ResetS1BufferFull = 79,
  ResetS2BufferFull = 80,
  ResetS3BufferFull = 81,
  ResetDBufferFull = 82,
  ResetMWrongMess = 83,
  ResetS0WrongMess = 84,
  ResetS1WrongMess = 85,
  ResetS2WrongMess = 86,
  ResetS3WrongMess = 87,
  ResetDWrongMess = 88,
  ResetMMaster = 89,
  ResetS0Master = 90,
  ResetS1Master = 91,
  ResetS2Master = 92,
  ResetS3Master = 93,
  ResetDMaster = 94,
  ResetMTimeOut = 95,
  ResetS0TimeOut = 96,
  ResetS1TimeOut = 97,
  ResetS2TimeOut = 98,
  ResetS3TimeOut = 99,
  ResetDTimeOut = 100,
  ResetMFcom = 101,
  ResetS0Fcom = 102,
  ResetS1Fcom = 103,
  ResetS2Fcom = 104,
  ResetS3Fcom = 105,
  ResetDFcom = 106,
  ResetMSlave = 107,
  VoltageOff = 108,
  SmokeDetectorBottom = 109,
  SkirtingMiddle = 110,
  PhaseControl = 111,
  RubberTop = 112,
  RubberBot = 113,
  BlockingDevice = 114,
  CombHeatingTop = 115,
  StepUpthrustBottom = 116,
  BrakeLining = 117,
  DeviceStopByCustomer = 118,
  DeviceWaterLevelBottom = 119,
  ContactorPickUp = 120,
  _00 = 121,
  _01 = 122,
  _02 = 123,
  _03 = 124,
  _04 = 125,
  _05 = 126,
  _06 = 127,
  _07 = 128,
  _08 = 129,
  _09 = 130,
  _0A = 131,
  _0B = 132,
  _0C = 133,
  _0D = 134,
  _0E = 135,
  _0F = 136,
  _18 = 137,
  _1C = 138,
  _20 = 139,
  _21 = 140,
  _22 = 141,
  _23 = 142,
  _27 = 143,
  _29 = 144,
  _37 = 145,
  _40 = 146,
  _42 = 147,
  _43 = 148,
  _46 = 149,
  _47 = 150,
  _5A = 151,
  _5B = 152,
  _5C = 153,
  _5D = 154,
  _5E = 155,
  _60 = 156,
  _61 = 157,
  _62 = 158,
  _63 = 159,
  _64 = 160,
  _65 = 161,
  _66 = 162,
  _67 = 163,
  _68 = 164,
  _69 = 165,
  _6A = 166,
  _6B = 167,
  _6C = 168,
  _6D = 169,
  _6E = 170,
  _6F = 171,
  _70 = 172,
  _71 = 173,
  _72 = 174,
  _73 = 175,
  _74 = 176,
  _75 = 177,
  _76 = 178,
  _77 = 179,
  _78 = 180,
  _79 = 181,
  _7A = 182,
  _7B = 183,
  _7C = 184,
  _7D = 185,
  _7E = 186,
  _7F = 187,
  _80 = 188,
  _81 = 189,
  _82 = 190,
  _83 = 191,
  _84 = 192,
  _85 = 193,
  _86 = 194,
  _87 = 195,
  _88 = 196,
  _89 = 197,
  _8A = 198,
  _8B = 199,
  _8C = 200,
  _8D = 201,
  _8E = 202,
  _8F = 203,
  _90 = 204,
  _91 = 205,
  _92 = 206,
  _93 = 207,
  _94 = 208,
  _95 = 209,
  _96 = 210,
  _97 = 211,
  _98 = 212,
  _99 = 213,
  _9A = 214,
  _9B = 215,
  _9C = 216,
  _9D = 217,
  _9E = 218,
  _9F = 219,
  _CC = 220,
  _CD = 221,
  _CE = 222,
  _CF = 223,
  _D0 = 224,
  _F0 = 225,
  _F1 = 226,
  _F2 = 227,
  _F3 = 228,
  _F4 = 229,
  _F5 = 230,
  _F6 = 231,
  _F7 = 232,
  _F8 = 233,
  _F9 = 234,
  _FA = 235,
  _FB = 236,
  _FC = 237,
  _FD = 238,
  _FE = 239,
  _FF = 240,
  OrderSpecific = 241,
  ContactorDropoutCheck = 242,
  HandRailEntryBottomRight = 243,
  HandRailEntryTopRight = 244,
  MissingStepTop = 245,
  MonitoringContactorTop = 246,
  Thermal = 247,
  _DC = 248,
  _DD = 249,
  _DE = 250,
  _DF = 251,
  MotorFailedToStop = 252,
  RedundantAccess = 253,
  RedundantCarBypass = 254,
  RedundantInsPmr = 255,
  BrakeIOFailedOff = 256,
  BrakeIOFailedOn = 257,
  CarComDeviceReset = 258,
  DonIoFailedOn = 259,
  DownDirectional = 260,
  DriveReady = 261,
  GsAndGs1Opposite = 262,
  HcComDeviceReset = 263,
  PInputOffFault = 264,
  PInputOnFault = 265,
  RunORunAFailed = 266,
  RunRunADNRFail = 267,
  RunRunAUpFail = 268,
  SafetyString = 269,
  DLBAndDLB1Opposite = 270,
  DLMAndDLM1Opposite = 271,
  DLTAndDLT1Opposite = 272,
  _13 = 273,
  _24 = 274,
  _4D = 275,
  _53 = 276,
  _E1 = 277,
  _E2 = 278,
  _E3 = 279,
  _E4 = 280,
  _E5 = 281,
  _E6 = 282,
  _E7 = 283,
  _E8 = 284,
  _E9 = 285,
  _EA = 286,
  _EB = 287,
  _EC = 288,
  _ED = 289,
  _EE = 290,
  _EF = 291
}
